<template>
  <div class="uk-flex uk-flex-wrap" uk-margin>
    <offer-modal :vehicle="vehicle" class=" uk-inline uk-margin-small-right"></offer-modal>
    <!--<button class="uk-button uk-button-secondary"><span class="uk-margin-small-right uk-icon" uk-icon="icon: bookmark"></span>Parken</button>
        <button class="uk-button uk-button-secondary"><span class="uk-margin-small-right uk-icon" uk-icon="icon: table"></span>vergleichen</button>
        <button class="uk-button uk-button-secondary"><span class="uk-margin-small-right uk-icon" uk-icon="icon: mail"></span>Anfragen</button>
        <button class="uk-button uk-button-secondary"><span class="uk-margin-small-right uk-icon" uk-icon="icon: clock"></span>Reservieren</button>-->
    <add-to-cart :disabled="vehicle.inCart" :vehicle-id="vehicle.id" @added="onAdded" v-if="showCart"></add-to-cart>
  </div>
</template>

<script>
import OfferModal from '@/components/vehicles/OfferModal.vue'
import AddToCart from '@/components/vehicles/AddToCart.vue'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    OfferModal,
    AddToCart
  },

  props: ['vehicle'],
  computed: {
    ...mapGetters(['config']),
    showCart() {
      if(this.vehicle.inPackage) {
        return false
      }
      if(this.config.general && this.config.general.disableCart) {
        return false
      }
      return true
    }
  },
  methods: {
    onAdded(data) {
      iziToast.success({
        title: 'Achtung!',
        message: 'Fahrzeug wurde in den Warenkorb gelegt!',
        timeout: 5000,
        position: 'topCenter'
      })
      this.$emit('addedToCart', data)
    }
  }
}
</script>
